$(document).ready(function () {
    if ($('.main-page .estimation').length === 1) {
        estimation.init();
    }
});

var estimation = {
    container: null,
    htmlEl: null,
    isBase: false,
    estimationId: null,
    projectId: null,
    vorschlagTotal: 0,
    data: {
        keyNumbers: {},
        compareIds: [],
        compare: {},
        projectIndex: null,
        projectVat: null,
    },

    init: function () {
        this.htmlEl = $('.main-page .estimation');
        this.container = $('#table');
        this.estimationId = this.container.attr('data-estimationId');
        this.projectId = this.container.attr('data-projectId');

        this.loadEstimation();
    },

    loadEstimation: function () {
        estimation.htmlEl.find('.main-content').applyLoader(true, "Lade Projektdaten ...");
        var tableUrl = "/ProjectEstimation/EstimationTable/" + estimation.estimationId;
        var data = {type: estimation.container.attr('data-type') || 'default'};
        connection.getHtmlPart(tableUrl, {
            timeout: 50000,
            data: data,
            onSuccess: function (data) {
                estimation.container.html(data);
                estimation.isBase = $('.meta [data-type]').attr('data-type') == "base";
                estimation.container.find('tr').addClass('level-1');
                $.each(estimation.container.find('.meta span'), function () {
                    var me = $(this);
                    $(me.attr('data-target')).html(me.attr('data-value'));
                });
                estimation.loaded();
            },
            onComplete: function () {
                estimation.htmlEl.find('.main-content').hideLoader();
            }
        });
    },

    loaded: function () {
        estimation.registerInputs(this.container);
        if ($('.autoopen').length == 1 && !slidein.isMobil && !slidein.isOpen) {
            slidein.openUrl($('.autoopen').attr('data-slidein'), function (element) {
            });
        }
        onContentReady(this.container);
        $(slidein).on('onOpen', function (ev, options) {
            estimation.container.find('.slidein-active').removeClass('slidein-active');
            if (options && options.linkEl && options.linkEl.is('tr')) {
                options.linkEl.addClass('slidein-active');
            }
        });
        this.container.find('[data-copy-value]').click(function() {
            var me = $(this);
            var valueEl = me.prev('[data-calculation]');
            var value = valueEl.html() || "0";
            me.closest('tr').find('.price-' + valueEl.attr('data-calculation'))
                .val(value)
                .trigger('blur');
        });
        //
        $('#estimationTableHeader [data-compare-id] [data-psync]').click(function () {
            var me = $(this).closest('[data-compare-id]');
            me.startProcess();
            debugger;
            estimation.loadComparisonData(me, me.attr('data-compare-id'));
        });

        var loadDataOf = $('#estimationTableHeader [data-compare-id]').toArray();
        estimation.loadAllComparisonData(loadDataOf);

        $('#estimationTableHeader [data-compare-id] [data-pinfo]').click(function () {
            var me = $(this).closest('[data-compare-id]');
            slidein.openUrl('/ProjectEstimation/EstimationOverviewSlidein/' + me.attr('data-compare-id'), function (element) {
            });
        });

        $('#estimationTableHeader [data-estimation-id] [data-pinfo]').click(function () {
            var me = $(this).closest('[data-estimation-id]');
            slidein.openUrl('/ProjectEstimation/KeyNumbersSlidein/' + me.attr('data-estimation-id'), function (element) {
            });
        });

        $('#estimationTableHeader .search-container').addClass('d-flex').removeClass('d-none');
        var searchField = $('#estimationTableHeader [name=PositionNumberSearch]');
        searchField.on('keyup', function() {
            var row = estimation.container.find('#an-' + searchField.val());
            if (row.length === 1) {
                var mainPosRow = $('[data-mainpos="'+searchField.val().substring(0, 1)+'"]');
                if (!mainPosRow.is('.opened')) {
                    mainPosRow.addClass('opened');
                }
                // console.log(estimation.htmlEl.scrollTop(), row.position(estimation.htmlEl).top, row);
                estimation.htmlEl.animate({
                    // scrollTop: estimation.htmlEl.scrollTop() + row.position(estimation.htmlEl).top - 5,
                    scrollTop: row.position(estimation.htmlEl).top - 5,
                }, 50);
            }
        });

        $('#estimationTableHeader .btn-reload').off('click').on('click', function() {
            estimation.loadEstimation();
        });
        $('#estimationTableHeader .btn-indent').off('click').on('click', function() {
            var indention = Math.min(4, parseInt(estimation.container.find('table').attr('data-indention')) + 1);
            estimation.container.find('table').attr('data-indention', indention);
        });
        $('#estimationTableHeader .btn-outdent').off('click').on('click', function() {
            var indention = Math.max(1, parseInt(estimation.container.find('table').attr('data-indention')) - 1);
            estimation.container.find('table').attr('data-indention', indention);
        });
        $('#estimationTableHeader .btn-hide-empty').off('click').on('click', function() {
            estimation.container.find('table').toggleClass('hide-empty');
        });

        estimation.data.projectIndex = parseFloat($('.estimation-header .project-col[data-index]').attr('data-index'));
        estimation.data.projectVat = parseFloat($('.estimation-header .project-col[data-vat]').attr('data-vat'));

        var compareHeaders = $('.estimation-header [data-compare-id]');
        estimation.data.compareVatOk = compareHeaders.filter(function() {
            return $(this).attr('data-vat') && $(this).attr('data-index');
        }).length === compareHeaders.length && estimation.data.projectIndex && estimation.data.projectVat;

        estimation.container.trigger('onLoaded', {target: estimation.container});
    },

    loadAllComparisonData: function (loadDataOf) {
        if (loadDataOf.length > 0) {
            var me = $(loadDataOf.shift());
            me.startProcess();
            estimation.loadComparisonData(me, me.attr('data-compare-id'), function() {
                estimation.loadAllComparisonData(loadDataOf);
            });
        }
    },

    loadComparisonData: function (el, id, onComplete) {
        connection.getJson('/ProjectEstimation/LoadComparisonData/' + id, {
            async: false,
            onComplete: function () {
                el.endProcess();
                if (onComplete) onComplete();
            },
            onError: function(response) {
                debugger;
            },
            onSuccess: function (data) {
                console.log(data);
                estimation.data.compare[id] = {
                    keyNumbers: data.KeyNumbers,
                    positions: data.Positions,
                };
                estimation.htmlEl.find('.main-content').applyLoader(true, "Lade gebaute Projekte ...");
                $.each(estimation.container.find('tr[data-posid]'), function () {
                    var row = $(this);
                    estimation.calculateComparisonRow(row, row.find('[data-compare]'));
                });
                registerFixedTableHeaders($('body'));
                estimation.htmlEl.find('.main-content').hideLoader();
            }
        });
    },

    calculateComparisonRow: function (row, compareCols) {
        var keyName = row.find('.key-name').attr('data-selected') || '';
        var positionNumberId = row.attr('data-posid');
        var archiNumber = row.attr('data-archinumber');
        var kennwerteSum = 0;
        var kennwerteCount = 0;
        var projectIndex = estimation.data.projectIndex;
        var projectVat = estimation.data.projectVat;

        $.each(compareCols, function () {
            var compareCol = $(this);
            var compareId = compareCol.attr('data-compare');
            if (estimation.data.compare[compareId]) {
                var positionData = estimation.data.compare[compareId].positions;
                var keyNumbersData = estimation.data.compare[compareId].keyNumbers;
                var compareKeyName = keyName;
                if (keyName === '' && positionData[archiNumber]) {
                    compareKeyName = positionData[archiNumber].KeyName || '';
                }
                if (compareKeyName && keyNumbersData[compareKeyName]) {
                    var am = parseFloat(keyNumbersData[compareKeyName].value);
                    var amValue = am.toFixed(2).FormatNumberForDisplay(2);
                    if (positionData[archiNumber] && positionData[archiNumber].HasDescription) {
                        amValue += '<span class="ml-1 badge badge-pill badge-light"><i class="fa bi-chat-dots"></i></span>';
                    }
                    row.find('.comp-am-' + compareId + '-' + positionNumberId).html(amValue);
                    if (positionData[archiNumber]) {
                        var weight = positionData[archiNumber].Weight;
                        var priceWeight = positionData[archiNumber].PriceWeight;
                        var nodePrice = positionData[archiNumber].NodeSum ?? positionData[archiNumber].Price;
                        var kw = (keyNumbersData[compareKeyName].value !== 0) ? parseFloat(nodePrice / keyNumbersData[compareKeyName].value) : 0;
                        if (kw !== 0) {
                            var baseKw = kw;
                            var kwCellEl = row.find('.comp-kw-' + compareId + '-' + positionNumberId);
                            if (estimation.data.compareVatOk) {
                                var compareIndex = row.find('[data-compare="'+compareId+'"]').attr('data-index');
                                var compareVat = parseFloat(row.find('[data-compare="'+compareId+'"]').attr('data-vat'));
                                var vatFactor = (1 + (projectVat / 100)) / (1 + (compareVat / 100));
                                var priceIndexFactor = projectIndex / compareIndex;
                                kw = kw * vatFactor * priceIndexFactor;
                                kwCellEl
                                    .attr('data-vat-factor', vatFactor)
                                    .attr('data-index-factor', priceIndexFactor);
                            }
                            kwCellEl
                                .html(kw.FormatNumberForDisplay(2))
                                .attr('title', keyNumbersData[compareKeyName].name + " ("+(keyNumbersData[compareKeyName].shortName || compareKeyName)+")")
                                .attr('data-base-value', baseKw)
                                .attr('data-weight', priceWeight);
                            row.find('.comp-am-' + compareId + '-' + positionNumberId)
                                .attr('title', keyNumbersData[compareKeyName].name + " ("+(keyNumbersData[compareKeyName].shortName || compareKeyName)+")")
                                .attr('data-key-number', keyNumbersData[compareKeyName].value)
                                .attr('data-weight', weight);
                            kennwerteSum += kw;
                            kennwerteCount++;
                        }
                    }
                } else {
                    row.find('.comp-am-' + compareId + '-' + positionNumberId).html('');
                    row.find('.comp-kw-' + compareId + '-' + positionNumberId).html('');
                }
                if (row.is('.leaf') && (compareKeyName || '') === '' && positionData[archiNumber]) {
                    var warningHtml = '<span class="ml-1 badge badge-pill badge-light text-danger" title="Einheit fehlt im gebauten Projekt"><i class="fa bi-exclamation-circle-fill"></i></span>';
                    row.find('.comp-am-' + compareId + '-' + positionNumberId).html(warningHtml);
                }
            }
        });
        // results
        if (kennwerteCount >= 0 && (keyName || '') !== '') {
            var kennwert = (kennwerteSum / kennwerteCount);
            if (!isNaN(kennwert)) {
                row.find('.proj-kw-' + positionNumberId).html(kennwert.FormatNumberForDisplay(2));
            }
            if (row.find('.mkv-' + positionNumberId).val() !== "") {
                kennwert = parseFloat(row.find('.mkv-' + positionNumberId).val());
            }
        } else if ((row.find('.mkv-' + positionNumberId).val() ||  "") !== "") {
            kennwert = parseFloat(row.find('.mkv-' + positionNumberId).val());
        }
        var vorschlagEl = row.find('.calculation-' + positionNumberId);
        if (kennwert) {
            var vorschlagValue = parseFloat(kennwert.toFixed(2) * ($('.meta .keyValue-' + keyName).attr('data-value') || 0));
            if (vorschlagValue < 0) {
                debugger;
            }
            vorschlagEl
                .attr('data-vorschlag', vorschlagValue)
                .html(vorschlagValue.FormatNumberForDisplay(0));
        } else {
            vorschlagEl
                .attr('data-vorschlag', 0)
                .html('');
            // row.find('.proj-amount-' + positionNumberId).html('');
        }
    },

    registerInputs: function (container) {
        var fields = container.find('input,textarea,[contenteditable]');
        connection.applyValueChange(fields, {
            onChange: function (formEl) {
                estimation.savePosition(formEl.closest('tr'));
                if (formEl.is('[data-name="mkv"]')) {
                    var tableRow = formEl.closest('tr');
                    estimation.calculateComparisonRow(tableRow, tableRow.find('[data-compare]'));
                }
            }
        });
        container.find('.select-dropdown').on('hidden.bs.dropdown', function () {
            var me = $(this);
            var selected = me.find('.active');
            estimation.changeAmountDropdownValueTo(me, selected.attr('data-value'), selected.attr('data-display'), selected.attr('data-price'));
            $.each($('.dropdown[data-keyname="'+me.attr('data-keyname')+'"]').not(me), function() {
                estimation.changeAmountDropdownValueTo($(this), selected.attr('data-value'), selected.attr('data-display'), selected.attr('data-price'));
            });
        });
        $.each(fields, function (i, el) {
            $(el).attr('data-val', $(el).val());
        });
    },

    changeAmountDropdownValueTo: function(dropdownEl, newKeyName, newKeyDisplayName, newKeyValue) {
        var tableRow = dropdownEl.closest('tr');
        dropdownEl.attr('data-selected', newKeyName);
        dropdownEl.find('button').html(newKeyDisplayName);
        estimation.savePosition(tableRow);
        tableRow.find('[data-amount]').html(newKeyName);
        debugger;
        // tableRow.find('[data-proj-amount]').html(newKeyValue || 0);
        tableRow.find('[data-key]').attr('data-key', newKeyName);
        if (!estimation.isBase) {
            estimation.calculateComparisonRow(tableRow, tableRow.find('[data-compare]'));
        }
    },

    changeKeyValue: function(keyName, newValue) {
        $('.meta .keyValue-' + keyName).attr('data-value', newValue);
        $('#estimationKeyMenu .keyValue-' + keyName).text(parseInt(newValue));
        if (estimation.container) {
            var keyValueFields = estimation.container.find('[data-key="' + keyName + '"]');
            keyValueFields.html(newValue);

            if (!estimation.isBase) {
                $.each(keyValueFields, function () {
                    var tableRow = $(this).closest('tr');
                    estimation.calculateComparisonRow(tableRow, tableRow.find('[data-compare]'));
                });
            }
        }
    },

    savePositions: function(positionsData) {
        estimation.htmlEl.find('.main-content').applyLoader(true, "Initialisiere Vergleichsprojekte ...");
        connection.getJson('/ProjectEstimation/SavePositions', {
            type: 'post',
            timeout: 120000,
            data: { positions: positionsData },
            onSuccess: function (data) {
            },
            onComplete: function () {
                estimation.htmlEl.find('.main-content').hideLoader();
            }
        });
    },

    savePosition: function (positionLine) {
        var keyName = positionLine.find('.key-name').attr('data-selected');
        var isMainPositionOfSammelposition = positionLine.next().attr('data-id') === positionLine.attr('data-id');

        if (!isMainPositionOfSammelposition) {
            var priceEl = positionLine.find('[data-name="price"]');
            var price = priceEl.val() || priceEl.text() || '';
            var manualKeyValue = positionLine.find('[data-name="mkv"]').val();
            estimation.savePositionField(positionLine.attr('data-est-pos-id'), positionLine.attr('data-id'), positionLine.attr('data-posid'), price, keyName, manualKeyValue);
        }
    },

    savePositionField: function (id, positionId, positionNumberId, price, keyName, manualKeyValue) {
        var task = {
            run: function (onComplete, onTaskError) {
                var postData = {
                    positionId: positionId,
                    positionNumberId: positionNumberId,
                    estimationId: estimation.estimationId,
                    data: {
                        price: price,
                        keyName: keyName,
                        manualKeyValue: manualKeyValue,
                    },
                };
                connection.getJson('/ProjectEstimation/SavePosition', {
                    type: 'post',
                    data: postData,
                    onSuccess: function (data) {
                    },
                    onError: function (data) {
                        if (data && data.statusText === 'timeout') {
                            onTaskError(null, true);
                            return;
                        }
                        onTaskError(connection.getErrorMessageOf(data, 'Fehler beim speichern der Position.'), false, function () {
                            //revert
                        });
                    },
                    onComplete: function () {
                        if (onComplete != null) onComplete();
                    }
                });
            }
        };
        taskQueue.add(task);
    }

};
window.estimation = estimation;
